// extracted by mini-css-extract-plugin
export default {"header":"Company_header__tmuyo","breadcrumbsWrapper":"Company_breadcrumbsWrapper__MCFp0","actions":"Company_actions__TIl-S"};